import { render, staticRenderFns } from "./RimconfigKbaInfoDialog.vue?vue&type=template&id=71376724"
import script from "./RimconfigKbaInfoDialog.vue?vue&type=script&lang=js"
export * from "./RimconfigKbaInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./RimconfigKbaInfoDialog.vue?vue&type=style&index=0&id=71376724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports